import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { Heading } from "components/Heading";
import Overview from "../tabs/Overview";
import useMcapFilters from "../useMcapFilters";
import typography from "../typography";

export default function OverviewScreen() {
  const { filters, renderFilterBar } = useMcapFilters();

  return (
    <div className="page-content">
      <Helmet>
        <title>{typography.TAB_OVERVIEW} · MCAP</title>
      </Helmet>
      <Container fluid className="mcap-hub">
        {/* Heading and filters share a row here — Overview's filter bar lost
            its School/Section pickers (see useMcapFilters), so what's left
            is just a date range and two small actions, and giving that its
            own full-width row under the heading was mostly empty space. The
            other screens keep filterBar on its own line below the heading;
            they still have enough in it to earn one. */}
        <div className="mcap-overview-header">
          <Heading heading={typography.TAB_OVERVIEW} />
          {renderFilterBar("overview", { showSchoolPicker: false })}
        </div>
        <Overview filters={filters} />
      </Container>
    </div>
  );
}
